import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickToLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M336 176V56h-38.627l-200 199.8L297.363 456H336V336h160V176Zm128 128H304v113.361L142.625 255.826L304 94.616V208h160ZM16 56h32v400H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickToLeft
